<template>
	<div class="legend-wrapper">
		<div v-for="(label, index) in labels" :key="'legend-' + index" :class="`has-status has-status--${label.color}`">
			{{ label.name }}
			<div v-if="totalCount > 0" class="legend-item__count">
				{{ Math.round((label.count / totalCount) * 100) }}%, {{ label.count }} von {{ totalCount }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { DecisionState, DecisionType, StatisticDecisionResponseItem } from '@/types/types';
import { defineComponent, PropType } from 'vue';

interface LabelOption {
	name: string;
	color: string;
	count: number;
}

export default defineComponent({
	name: 'ChartLegend',
	components: {},
	props: {
		type: {
			type: String as PropType<DecisionType>,
			required: true,
		},
		data: {
			type: Object as PropType<StatisticDecisionResponseItem[] | null>,
		},
	},
	data() {
		return {
			totalCount: 0,
		};
	},
	computed: {
		labels() {
			let options: LabelOption[] = [];
			if (this.type === DecisionType.SmallSenate) {
				options = [
					{
						name: this.$getStateFullLabel('decision', DecisionState.StopSmallSenate, false),
						color: this.$getStateColor('decision', DecisionState.GoSmallSenate),
						count: this.data?.find((d) => d.decisionState === DecisionState.StopSmallSenate)?.count || 0,
					},
					{
						name: this.$getStateFullLabel('decision', DecisionState.GoSmallSenate, false),
						color: this.$getStateColor('decision', DecisionState.StopSmallSenate),
						count: this.data?.find((d) => d.decisionState === DecisionState.GoSmallSenate)?.count || 0,
					},
				];
			} else if (this.type === DecisionType.Werberat || this.type === DecisionType.JungerWerberat) {
				options = [
					{
						name: this.$getStateFullLabel('decision', DecisionState.Biased, false),
						color: this.$getStateColor('decision', DecisionState.Biased),
						count: this.data?.find((d) => d.decisionState === DecisionState.Biased)?.count || 0,
					},
					{
						name: this.$getStateFullLabel('decision', DecisionState.NoReason, false),
						color: this.$getStateColor('decision', DecisionState.NoReason),
						count: this.data?.find((d) => d.decisionState === DecisionState.NoReason)?.count || 0,
					},
					{
						name: this.$getStateFullLabel('decision', DecisionState.Awareness, false),
						color: this.$getStateColor('decision', DecisionState.Awareness),
						count: this.data?.find((d) => d.decisionState === DecisionState.Awareness)?.count || 0,
					},
					{
						name: this.$getStateFullLabel('decision', DecisionState.Stop, false),
						color: this.$getStateColor('decision', DecisionState.Stop),
						count: this.data?.find((d) => d.decisionState === DecisionState.Stop)?.count || 0,
					},
				];
			}

			if (this.data) {
				// if we dispaly data - only display labels with counts
				options = options.filter((o) => o.count > 0);
			}

			options = options.map((o) => {
				return { ...o, name: o.name.replace('Entscheidung: ', '') };
			});

			return options;
		},
	},
	mounted() {
		if (this.data) {
			this.data?.forEach((d) => (this.totalCount += d.count || 0));
		}
	},
});
</script>
